import { Typography } from "@mui/material";

const ChatFormLabel = ({ label }: { label: string }) => {
  return (
    <Typography variant="body2" gutterBottom fontWeight="bold">
      {label}
    </Typography>
  );
};

export default ChatFormLabel;
